// Specialty Model

import { Model } from '@vuex-orm/core'
import Specialty from './Specialty'

export default class Pathology extends Specialty {
  static entity = 'pathology'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields(),
      diagnoses: this.attr([]),
      organSystems: this.attr([])
    }
  }

  static getLabel(log, component) {
    const item = log[component.id]
    if (component.id === 'diagnosis-histo') {
      return (
        PathologyDiagnosis.query()
          .whereId(item)
          .first() || {}
      ).name
    } else {
      return super.getLabel(log, component)
    }
  }
}

export class OrganSystem extends Model {
  static entity = 'organSystems'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      diagnoses: this.hasMany(PathologyDiagnosis, 'organSystem'),
      organs: this.hasMany(Organ, 'organSystem')
    }
  }
}

export class Organ extends Model {
  static entity = 'organs'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      organSystem: this.string(),
      organSystemInstance: this.belongsTo(OrganSystem, 'organSystem')
    }
  }
}

export class LesionType extends Model {
  static entity = 'lesionTypes'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      name: this.string()
    }
  }
}

export class PathologyDiagnosis extends Model {
  static entity = 'pathologyDiagnoses'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      lesionType: this.string(),
      lesionTypeInstance: this.belongsTo(LesionType, 'lesionType'),
      organSystem: this.string(),
      organSystemInstance: this.belongsTo(OrganSystem, 'organSystem')
    }
  }
}
